import { AxiosInstance } from 'axios'

import {
  ProcessingDocument,
  mapCubeToProcessingDocument,
  ProcessingCrunchEntry,
} from '@dc-shared-web/lib/cubeMappers'

export type ProcessingDocumentParams = {
  sort?: string
  sortDirection?: 'desc' | 'asc'
  offset?: number
  currentTeam?: string
  uuids: string[]
}

export const fetchProcessingDocuments = async (
  apiClient: AxiosInstance,
  params: ProcessingDocumentParams
): Promise<ProcessingDocument[]> => {
  try {
    const { data } = await apiClient.get<ProcessingCrunchEntry[]>(
      `/ajax/cube/processingCrunch`,
      {
        params: {
          ...params,
          sort: 'Crunch.created_at',
          sortDirection: 'desc',
          offset: 0,
        },
      }
    )
    return data.map(mapCubeToProcessingDocument)
  } catch (error) {
    return []
  }
}
